<template>
  <b-field
    :label="label"
    :custom-class="customLabelClass"
    :type="type"
    :class="type"
    :message="firstErrorMessage"
    v-bind="$attrs"
  >
    <template #label>
      <slot name="label"></slot>
    </template>
    <slot />
  </b-field>
</template>
<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  name: 'FormGroup',
  extends: singleErrorExtractorMixin,
  props: {
    customClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    type() {
      return this.hasErrors ? 'is-danger' : this.isValid ? '' : null
    },
    customLabelClass() {
      let customClass = this.customClass

      if (this.hasErrors) {
        return customClass + ' has-text-danger'
      } else {
        return customClass
      }
    }
  }
}
</script>
